import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const GroupsView = angular
  .module('acme.view.application.groups', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.groups.controllers',
    'acme.view.application.groups.list',
    'acme.view.application.groups.users',
    'acme.view.application.groups.roles',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const groups = {
      name: 'application.groups',
      url: '/groups',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'GroupsController',
          templateUrl: 'views/application/views/groups/groups.tpl.html',
        },
      },
    };

    $stateProvider.state(groups);
  }).name;
